/* eslint-disable react/jsx-props-no-spreading */
import { useState } from 'react';
import styled from 'styled-components';
import { useSwipeable } from 'react-swipeable';

const Container = styled.div`
  width: 100vw;
  height: 50px;
  display: flex;
  justify-content: space-between;
  position: relative;
`;

const Left = styled.div`
  width: 50%;
  background-color: #48d0c7;
  transform: translateX(${({ x }) => `${x}px`});
  color: white;
  display: flex;
  justify-content: flex-end;
  padding-right: 25px;
  align-items: center;
  &:before {
    content: '';
    position: absolute;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 10px solid #48d0c7;
    width: 0;
    height: 0;
    left: 100%;
  }
`;

const Right = styled.div`
  width: 50%;
  background-color: #48d0c7;
  transform: translateX(${({ x }) => `${x}px`});
  /* transform: translateX(50px); */
  color: white;
  display: flex;
  justify-content: flex-start;
  padding-left: 25px;
  align-items: center;
  transition: all 0s ease;

  &:before {
    content: '';
    position: absolute;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #48d0c7;
    width: 0;
    height: 0;
    right: 100%;
  }
`;

const LeftArrow = ({ disabled, onSwipeLeft }) => {
  const [isSwiping, setIsSwiping] = useState(false);
  const [x, setX] = useState(null);
  const handlers = useSwipeable({
    onSwipeStart: () => !disabled && setIsSwiping(true),
    onSwiped: (evt) => {
      if (disabled) return;
      if (Math.abs(evt.deltaX) > 100) onSwipeLeft();
      setIsSwiping(false);
    },
    onSwiping: (evt) => {
      if (evt.dir === 'Left') return;
      if (evt.deltaX > 149) return;
      setX(evt.deltaX);
    },
    ...{
      delta: 0, // min distance(px) before a swipe starts. *See Notes*
      preventDefaultTouchmoveEvent: true, // call e.preventDefault *See Details*
      trackTouch: true, // track touch input
      trackMouse: false, // track mouse input
      rotationAngle: 0, // set a rotation angle
    },
  });
  return (
    <Left
      {...handlers}
      style={{
        transform: `translateX(${isSwiping ? (x - 150) : -150}px)`
      }}
    >
      Not Recycleable
    </Left>
  );
};

const RightArrow = ({ disabled, onSwipeRight }) => {
  const [isSwiping, setIsSwiping] = useState(false);
  const [x, setX] = useState(null);
  const handlers = useSwipeable({
    onSwipeStart: () => !disabled && setIsSwiping(true),
    onSwiped: (evt) => {
      if (disabled) return;
      if (Math.abs(evt.deltaX) > 100) onSwipeRight();
      setIsSwiping(false);
    },
    onSwiping: (evt) => {
      if (evt.dir === 'Right') return;
      if (Math.abs(evt.deltaX) > 149) return;
      setX(evt.deltaX);
    },
    ...{
      delta: 0, // min distance(px) before a swipe starts. *See Notes*
      preventDefaultTouchmoveEvent: true, // call e.preventDefault *See Details*
      trackTouch: true, // track touch input
      trackMouse: false, // track mouse input
      rotationAngle: 0, // set a rotation angle
    },
  });
  return (
    <Right
      {...handlers}
      style={{
        transform: `translateX(${isSwiping ? (x + 150) : 150}px)`
      }}
    >
      Recycleable
    </Right>
  );
};

const Swiper = ({ disabled, onSwipeLeft, onSwipeRight }) => (
  <Container>
    <LeftArrow
      disabled={disabled}
      onSwipeLeft={onSwipeLeft}
    />
    <RightArrow
      disabled={disabled}
      onSwipeRight={onSwipeRight}
    />
  </Container>
);

export default Swiper;
